import * as React from 'react';
import { List, Avatar } from 'antd';
import Truncate from 'react-truncate';
import { Link } from "react-router-dom";

import { ROUTE_NAMES } from '@bakbak/common';
import { GetPostListQuery_getPostList } from "@bakbak/controller";

interface Props {
  post: GetPostListQuery_getPostList;
}
interface State {
  width: number;
}
const clickableStyle = { color: 'blue' };

export class PostItemView extends React.PureComponent<Props, State> {
  state = { width: 900 };
  componentWillMount() {
    this.setState(() => ({ width: window.innerWidth }));
  }
  render() {
    const { post } = this.props;
    return (
      <List.Item key={post.title}>
        <List.Item.Meta
          avatar={<Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" />}
          title={<Link to={`${ROUTE_NAMES.POST_DETAILS}/${post.id}`} style={clickableStyle}>{post.title}</Link>}
        />
        <Truncate lines={3} ellipsis={
          <Link to={`${ROUTE_NAMES.POST_DETAILS}/${post.id}`} style={clickableStyle}>
            ...Read more
          </Link>
        } width={this.state.width - 350}>
          {post.details}
        </Truncate>
        <div>By: {post.author.userName}</div>
      </List.Item>
    );
  }
}

// const voteIconStyle = {
//   color: 'red',
// };


// WEBPACK FOOTER //
// ./src/modules/post/item/PostItemView.tsx